// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC62Koi8fXvL__yblPWbO9zE538wrfYTaY",
  authDomain: "adibilismvp2react.firebaseapp.com",
  projectId: "adibilismvp2react",
  storageBucket: "adibilismvp2react.appspot.com",
  messagingSenderId: "636718177479",
  appId: "1:636718177479:web:18178dd1ea2665fe6af2e2",
  measurementId: "G-9BY7HCS6G2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { db };


